import "react-datetime/css/react-datetime.css";

import React from "react";
import Datetime from "react-datetime";

function DateTimeRangeComponent({ min, max, Dyn, mode, label, onChange }) {

    function getLoc(str) {
        return Dyn.loc(str);
    }

    let dateFormat = true,
        timeFormat = true,
        key = "datetime";

    if (mode == "date") {
        dateFormat = 'YYYY-MM-DD';
        timeFormat = false;
        key = "date";
    } else if (mode == "time") {
        dateFormat = false;
        // timeFormat = 'HH:mm:ss';
        key = "time";
    } else if (mode == "yearMonth" || mode == "monthYear") {
        // if Number is already updated, trying to get monthYear will return NaN
        if (Dyn.dataUtil.monthYearSerialToDate(min)) {
            min = Dyn.dataUtil.monthYearSerialToDate(min);
        }
        if (Dyn.dataUtil.monthYearSerialToDate(max)) {
            max = Dyn.dataUtil.monthYearSerialToDate(max);
        }
        dateFormat = "YYYY-MM";
        timeFormat = false;
        key = "yearMonth";
    } else if (mode == 'datetime') {
        dateFormat = 'YYYY-MM-DD';
        timeFormat = 'hh:mm:ss A';
        key = 'datetime';
    }

    // checking if while converting from categorical to numerical if there is
    // no valid numeric value.
    if (typeof min === "undefined" || typeof max === "undefined") {
        return (
            <div className="tde-numeric-component">
                <div className="tde-m-2 tde-text-error tde-err-msg-text-color">
                    {getLoc("No valid numeric value for the attribute.")}
                </div>
            </div>
        );
    } else {
        return (
            <div className="tde-flex">
                <div className="tde-row tde-my-2">
                    <div className="tde-label tde-mb-2">{getLoc("Min")}</div>
                    <Datetime
                        value={min}
                        key={key}
                        className="tde-input tde-input-parent"
                        dateFormat={dateFormat}
                        timeFormat={timeFormat}
                        ariaLabel={'Minimum ' + label + ' Value'}
                        onChange={(e) => {
                            if( e._d) onChange([e._d.valueOf(), max]);
                        }}
                    />
                </div>
                <div className="tde-row tde-my-2">
                    <div className="tde-label tde-mb-2">{getLoc("Max")}</div>
                    <Datetime
                        value={max}
                        key={key}
                        className="tde-input tde-input-parent"
                        dateFormat={dateFormat}
                        timeFormat={timeFormat}
                        ariaLabel={'Maximum ' + label + ' Value'}
                        onChange={(e) => {
                            if( e._d) onChange([min, e._d.valueOf()]);
                        }}
                    />
                </div>
            </div>
        );
    }
}

export default DateTimeRangeComponent;
